// extracted by mini-css-extract-plugin
module.exports = {"popover":"floaters_popover__ebT6N","tooltip":"floaters_tooltip__xpPtS","arrow":"floaters_arrow__yKKm4","mondayTooltip":"floaters_mondayTooltip__y_uDU"};